module.exports = __webpack_public_path__ + "img/bg_1024.12f93cf5.png";